export class CssPropertiesIntersections {
  #state: Record<
    string,
    {
      key: string;
      encodeValue?: (currentValue: string, partialValue: string) => string;
      decodeValue?: (currentValue: string) => string;
    }
  > = {};

  #intersections = new Map<string, string[]>();

  addRule(
    combination: [string, string],
    config: {
      key: string;
      encodeValue?: (currentValue: string, partialValue: string) => string;
      decodeValue?: (currentValue: string) => string;
    },
  ) {
    combination.forEach((x, index) => {
      const values = this.getPossibleIntersections(x);

      this.#intersections.set(x, [
        ...values,
        ...combination.filter((_, _index) => index !== _index),
      ]);
    });

    const idx = [...combination].sort().join('_');
    this.#state[idx] = config;
  }

  getPossibleIntersections(rule: string) {
    return this.#intersections.get(rule) ?? [];
  }

  isIntersected(combination: [string, string]): {
    key: string;
    encodeValue?: (currentValue: string, partialValue: string) => string;
    decodeValue?: (currentValue: string) => string;
  } | null {
    const idx = [...combination].sort().join('_');

    const intersection = this.#state[idx];

    if (intersection) {
      return {
        key: intersection.key,
        encodeValue: intersection.encodeValue,
        decodeValue: intersection.decodeValue,
      };
    }

    return null;
  }
}

export const cssPropertiesIntersections = new CssPropertiesIntersections();

// cssPropertiesIntersections.addRule(['border', 'border-color'], {
//   key: 'border-color',
//   encodeValue: (currentValue, partialValue) => {
//     const e = currentValue.split(' ')[2];
//     return currentValue.replace(e, partialValue);
//   },
//   decodeValue: (currentValue) => {
//     return currentValue.split(' ')[2];
//   },
// });
